<template>
  <div class="mb-4">
    <div class="flex items-center justify-between">
      <label :for="name">{{ label }}</label>
      <span v-if="optional === 'true' || !rules" class="text-muted">
        Optional
      </span>
    </div>

    <ValidationProvider
      :name="name"
      :rules="rules"
      v-slot="{ classes, errors }"
    >
      <input
        v-if="
          type == 'text' ||
            type == 'password' ||
            type == 'tel' ||
            type == 'email' ||
            type == 'number'
        "
        :class="classes"
        :id="name"
        :placeholder="placeholder"
        :type="type"
        :maxlength="maxlength"
        :min="min"
        :max="max"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
      />

      <textarea
        v-if="type == 'textarea'"
        rows="5"
        :class="classes"
        :id="name"
        :placeholder="placeholder"
        :type="type"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
      ></textarea>

      <select
        v-if="type == 'select'"
        rows="5"
        :class="classes"
        :id="name"
        :placeholder="placeholder"
        :type="type"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
      >
        <option value selected disabled>Select {{ name }}</option>
        <option v-for="(value, key) in options" :value="key" :key="key">{{
          value
        }}</option>
      </select>

      <p v-if="help" class="text-help">{{ help }}</p>
      <p class="errors">{{ errors[0] }}</p>
    </ValidationProvider>
  </div>
</template>

<script>
import { extend } from "vee-validate";

extend("passwordCheck", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Password confirmation does not match",
});

extend("passwordPolicy", {
  params: ["target"],
  validate(value) {
    const regex = RegExp(`((?=.*\\d)(?=.*[A-Z])(?=.*\\W*).{8,})`);
    return regex.test(value);
  },
  message:
    "Password shall have at least 8 characters being 1 UPPER case, 1 lower case and 1 numeric. ",
});

extend("gc", (value) => {
  if (value === "true") {
    return true;
  }
  return "You must be a US citizen or a green card holder to participate in the program";
});

export default {
  name: "ChiInput",
  props: [
    "value",
    "type",
    "placeholder",
    "rules",
    "label",
    "name",
    "help",
    "maxlength",
    "min",
    "max",
    "optional",
    "options",
  ],
};
</script>

<style scoped>
label {
  @apply block;
  @apply text-sm;
  @apply font-semibold;
  @apply mb-2;
}

input:not([type="submit"]),
select,
textarea {
  border: 1px solid rgba(0, 0, 0, 0.25);
  font-size: 1rem;
  @apply appearance-none;
  @apply block;
  @apply w-full;
  @apply rounded;
  @apply py-3;
  @apply px-4;
  @apply mb-1;
}

input:not([type="submit"]):focus,
select:focus,
textarea:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

textarea.touched.is-invalid,
select.touched.is-invalid,
input.touched.is-invalid {
  border: 1px solid #dc3545;
}

select.touched.is-valid,
textarea.touched.is-valid,
input.touched.is-valid {
  border: 1px solid #28a745;
}

select.touched.is-invalid:focus,
textarea.touched.is-invalid:focus,
input.touched.is-invalid:focus {
  border: 1px solid #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(240, 0, 0, 0.25);
}

select.touched.is-valid:focus,
textarea.touched.is-valid:focus,
input.touched.is-valid:focus {
  border: 1px solid #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.4);
}

.text-muted {
  font-size: 0.8rem;
  font-style: italic;
  font-weight: 400;
}

.text-help {
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
}
</style>
